import Controller from '../abstracts/Controller';
import 'scss-templates/t-cart.scss';

export default class CartController extends Controller {
  static get COMPONENTS() {
    return [
      'CartComponent',
      'PromocodeComponent',
      'RecaptchaComponent',
      'GoogleRecommendationEngineComponent',
      'RecommendationEngineComponent',
      'StoreLocatorComponent',
    ];
  }

  scrollIfError() {
    if ($('#cart-authentication').data('checkoutloginError')) {
      window.scrollTo(0,document.querySelector('#cart-authentication').scrollHeight+500);
    }
  }

  init() {
    super.init();
    this.scrollIfError();
  }
}
